import 'components/_common-styles/index.scss';
import FormType from 'constants/form-type';
import FormVariant from 'constants/form-variant';
import LoginForm from 'components/login-form';
import LoginBubble from 'components/login-bubble';
import UiActions from 'logic/ui-actions';
import TrackingAction from 'constants/tracking-action';
import PlatformDetection from 'infrastructure/platform-detection';

var jwfLoginComponentId = 0;

function createInstance() {
    let instanceComponentId = jwfLoginComponentId++;

    return {
        componentId: instanceComponentId,
        LoginForm: LoginForm,
        LoginBubble: LoginBubble,
        FormType: FormType,
        FormVariant: FormVariant,
        Api: {
            initBubble: (placeHolder, params) => { UiActions.initBubble(placeHolder, params, instanceComponentId); },
            showBubble: (event) => { UiActions.showBubble(event, instanceComponentId); },
            hideBubble: () => { UiActions.hideBubble(instanceComponentId); },
            createForm: (placeHolder, params) => { UiActions.createForm(placeHolder, params, instanceComponentId); },
            getClsLoginUrl: () => { return UiActions.getClsLoginUrl(instanceComponentId); }
        },
        _TrackingAction: TrackingAction,
        _Api: {
            trackUiEvent: (trackingValue, cId) => { UiActions.trackUiEvent(trackingValue, cId ? cId : instanceComponentId); },
            showProductInformation: (cId) => { UiActions.showProductInformation(cId ? cId : instanceComponentId); },
            termsLinkClicked: (cId) => { UiActions.termsLinkClicked(cId ? cId : instanceComponentId); },
            privacyLinkClicked: (cId) => { UiActions.privacyLinkClicked(cId ? cId : instanceComponentId); },
            federatedLoginLinkClicked: (clsLoginUrl, cId) => { UiActions.federatedLoginLinkClicked(clsLoginUrl, cId ? cId : instanceComponentId); },
            existingLoginLinkClicked: (hasPassword, cId) => { UiActions.existingLoginLinkClicked(hasPassword, cId ? cId : instanceComponentId); },
        }
    }
}

if (!PlatformDetection.os.isSupported || !PlatformDetection.browser.isSupported) {
    throw new Error('Login component is not supported on this platform!!!');
}

let moduleExports = createInstance();
moduleExports.createInstance = createInstance;
module.exports = moduleExports;


/** WEBPACK FOOTER **
 ** ./src/index.js
 **/